"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const button_1 = require("primereact/button");
const orderInvoiceLayout_module_scss_1 = __importDefault(require("./orderInvoiceLayout.module.scss"));
const react_i18next_1 = require("react-i18next");
const BackButton = ({ onClick }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(button_1.Button, { icon: "pi pi-arrow-left", className: orderInvoiceLayout_module_scss_1.default.backButton, tooltip: t('back'), tooltipOptions: {
            position: 'bottom',
            mouseTrack: true,
            mouseTrackTop: 15,
            className: 'custom-tooltip',
        }, onClick: onClick }));
};
exports.BackButton = BackButton;
